{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCWXOCRHelper;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF LCLLIB}
{$DEFINE LCLWEBLIB}
{$ENDIF}

{$IFDEF MSWINDOWS}
{$DEFINE USEEDGE}
{$ENDIF}

{$IFDEF USEEDGE}
{$DEFINE EDGESUPPORT}
{$ENDIF}

interface

uses
  {$IFDEF FMXLIB}
   FMX.Types, System.Messaging, FMX.Ani,  FMX.Objects,
  {$ENDIF}
  {$IFDEF VCLLIB}
  {$ENDIF}
  {$IFDEF WEBLIB}
  JS,
  {$ENDIF}
  UITypes, Types, Classes, TypInfo, SysUtils,  Variants, WEBLib.TMSFNCPersistence,
  WEBLib.Controls, WEBLib.Forms, WEBLib.Graphics, WEBLib.Dialogs, WEBLib.TMSFNCTypes, WEBLib.TMSFNCUtils,
  WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCCustomControl, WEBLib.TMSFNCWebBrowser, WEBLib.TMSFNCCustomWEBControl,
  WEBLib.TMSFNCCustomWEBComponent, WEBLib.TMSFNCWXOCR
  {$IFNDEF WEBLIB}
  {$IFDEF LCLLIB}
  ,fgl
  {$ELSE}
  ,Generics.Collections
  {$ENDIF}
  {$ELSE}
  ,Contnrs
  {$ENDIF}
  ;

type
  TTMSFNCWXOCRHelperSelectionResult = class(TPersistent)
  private
    FID: String;
    FBitmap: TTMSFNCBitmap;
    FRectangle: TRectF;
    FOCRResult: TTMSFNCWXOCRResult;
    FFeedbackDPIScale: Single;
    FSelectionDPIScale: Single;
    FInProgress: Boolean;
    FFromTemplate: Boolean;
  published
    property ID: String read FID write FID;
    property FeedbackDPIScale: Single read FFeedBackDPIScale write FFeedBackDPIScale;
    property SelectionDPIScale: Single read FSelectionDPIScale write FSelectionDPISCale;
    property Bitmap: TTMSFNCBitmap read FBitmap write FBitmap;
    property OCRResult: TTMSFNCWXOCRResult read FOCRResult write FOCRResult;
    property InProgress: Boolean read FInProgress write FInProgress;
    property FromTemplate: Boolean read FFromTemplate write FFromTemplate;
  public
    property Rectangle: TRectF read FRectangle write FRectangle;
    destructor Destroy; override;
  end;

  TTMSFNCWXOCRHelperRectangle = class(TPersistent)
  private
    FLeft, FRight, FTop, FBottom: Single;
    FDPIScale: Single;
  published
    property Left: Single read FLeft write FLeft;
    property Right: Single read FRight write FRight;
    property Top: Single read FTop write FTop;
    property Bottom: Single read FBottom write FBottom;
    property DPIScale: Single read FDPIScale write FDPIScale;
  end;

  {$IFNDEF WEBLIB}
  TTMSFNCWXOCRHelperSelectionResults = class(TObjectList<TTMSFNCWXOCRHelperSelectionResult>);
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCWXOCRHelperSelectionResults = class(TObjectList)
  private
    function GetItem(Index: Integer): TTMSFNCWXOCRHelperSelectionResult;
    procedure SetItem(Index: Integer; const Value: TTMSFNCWXOCRHelperSelectionResult);
  public
    property Items[Index: Integer]: TTMSFNCWXOCRHelperSelectionResult read GetItem write SetItem; default;
  end;
  {$ENDIF}

  {$IFNDEF WEBLIB}
  TTMSFNCWXOCRHelperSelectionTemplate = class(TObjectList<TTMSFNCWXOCRHelperRectangle>, ITMSFNCBaseListIO, ITMSFNCBasePersistenceIO)
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCWXOCRHelperSelectionTemplate = class(TObjectList, ITMSFNCBaseListIO, ITMSFNCBasePersistenceIO)
  {$ENDIF}
  private
    FOwnerInterface: IInterface;
    {$IFDEF WEBLIB}
    function GetItem(Index: Integer): TTMSFNCWXOCRHelperRectangle;
    procedure SetItem(Index: Integer; const Value: TTMSFNCWXOCRHelperRectangle);
    {$ENDIF}
  protected
    function GetItemClass: TClass;
    function CreateObject(const AClassName: string; const ABaseClass: TClass): TObject;
    { IInterface }
    function _AddRef: {$IFDEF LCLLIB} LongInt; {$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};{$ELSE} Integer;{$IFNDEF WEBLIB} stdcall; {$ENDIF}{$ENDIF}
    function _Release: {$IFDEF LCLLIB} LongInt; {$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};{$ELSE} Integer;{$IFNDEF WEBLIB} stdcall; {$ENDIF}{$ENDIF}
  public
    {$IFDEF WEBLIB}
    property Items[Index: Integer]: TTMSFNCWXOCRHelperRectangle read GetItem write SetItem; default;
    {$ENDIF}
    {$IFDEF LCLLIB}
    function QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} IID: TGUID; out Obj): HResult; {$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
    {$ELSE}
    function QueryInterface(const IID: TGUID; out Obj): HResult; virtual; {$IFNDEF WEBLIB} stdcall; {$ENDIF}
    {$ENDIF}
  end;

  TTMSFNCWXOCRHelperAppearance = class(TPersistent)
  private
    FOwner: TComponent;
    FOnChange: TNotifyEvent;
    FDragFill: TTMSFNCGraphicsFill;
    FDragStroke: TTMSFNCGraphicsStroke;
    FSelectionFill: TTMSFNCGraphicsFill;
    FSelectionStroke: TTMSFNCGraphicsStroke;
    FLowConfidenceFill: TTMSFNCGraphicsFill;
    FLowConfidenceStroke: TTMSFNCGraphicsStroke;
    FModerateConfidenceFill: TTMSFNCGraphicsFill;
    FModerateConfidenceStroke: TTMSFNCGraphicsStroke;
    FReasonableConfidenceFill: TTMSFNCGraphicsFill;
    FReasonableConfidenceStroke: TTMSFNCGraphicsStroke;
  protected
    procedure Changed;
    procedure FillChanged(Sender: TObject);
    procedure StrokeChanged(Sender: TObject);
    procedure SetDragFill(const Value: TTMSFNCGraphicsFill);
    procedure SetDragStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetSelectionFill(const Value: TTMSFNCGraphicsFill);
    procedure SetSelectionStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetLowConfidenceFill(const Value: TTMSFNCGraphicsFill);
    procedure SetLowConfidenceStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetModerateConfidenceFill(const Value: TTMSFNCGraphicsFill);
    procedure SetModerateConfidenceStroke(const Value: TTMSFNCGraphicsStroke);
    procedure SetReasonableConfidenceFill(const Value: TTMSFNCGraphicsFill);
    procedure SetReasonableConfidenceStroke(const Value: TTMSFNCGraphicsStroke);
  published
    property DragFill: TTMSFNCGraphicsFill read FDragFill write SetDragFill;
    property DragStroke: TTMSFNCGraphicsStroke read FDragStroke write SetDragStroke;
    property SelectionFill: TTMSFNCGraphicsFill read FSelectionFill write SetSelectionFill;
    property SelectionStroke: TTMSFNCGraphicsStroke read FSelectionStroke write SetSelectionStroke;
    property LowConfidenceFill: TTMSFNCGraphicsFill read FLowConfidenceFill write SetLowConfidenceFill;
    property LowConfidenceStroke: TTMSFNCGraphicsStroke read FLowConfidenceStroke write SetLowConfidenceStroke;
    property ModerateConfidenceFill: TTMSFNCGraphicsFill read FModerateConfidenceFill write SetModerateConfidenceFill;
    property ModerateConfidenceStroke: TTMSFNCGraphicsStroke read FModerateConfidenceStroke write SetModerateConfidenceStroke;
    property ReasonableConfidenceFill: TTMSFNCGraphicsFill read FReasonableConfidenceFill write SetReasonableConfidenceFill;
    property ReasonableConfidenceStroke: TTMSFNCGraphicsStroke read FReasonableConfidenceStroke write SetReasonableConfidenceStroke;
  public
    constructor Create(AOwner: TComponent);
    destructor Destroy; override;
    procedure Assign(Source: TPersistent); override;
    property OnChange: TNotifyEvent read FOnChange write FOnChange;
  end;

  TTMSFNCWXOCRCustomHelper = class(TTMSFNCCustomControl)
  private
    FEnableSelection: Boolean;
    FEnableFeedback: Boolean;
    FBitmap: TTMSFNCBitmap;
    FOCR: TTMSFNCWXOCR;
    FAppearance: TTMSFNCWXOCRHelperAppearance;
    FLowConfidence: Single;
    FModerateConfidence: Single;
    FReasonableConfidence: Single;
    FDX, FDY: Single;
    FSX, FSY: Single;
    FDown: Boolean;
    FWidthMultiplier, FHeightMultiplier: Single;
    FAutoStart: Boolean;
    FSelectionResults: TTMSFNCWXOCRHelperSelectionResults;
    procedure SetEnableSelection(const Value: Boolean);
    procedure SetEnableFeedback(const Value: Boolean);
    procedure SetOCR(const Value: TTMSFNCWXOCR);
    procedure SetBitmap(const Value: TTMSFNCBitmap);
    procedure SetLowConfidence(const Value: Single);
    procedure SetModerateConfidence(const Value: Single);
    procedure SetReasonableConfidence(const Value: Single);
    procedure SetAppearance(const Value: TTMSFNCWXOCRHelperAppearance);
    procedure SetAutoStart(const Value: Boolean);
  protected
    property AutoStart: Boolean read FAutoStart write SetAutoStart default false;
    property EnableSelection: Boolean read FEnableSelection write SetEnableSelection default true;
    property EnableFeedback: Boolean read FEnableFeedback write SetEnableFeedback default true;
    property OCR: TTMSFNCWXOCR read FOCR write SetOCR;
    property Bitmap: TTMSFNCBitmap read FBitmap write SetBitmap;
    property LowConfidence: Single read FLowConfidence write SetLowConfidence;
    property ModerateConfidence: Single read FModerateConfidence write SetModerateConfidence;
    property ReasonableConfidence: Single read FReasonableConfidence write SetReasonableConfidence;
    property Appearance: TTMSFNCWXOCRHelperAppearance read FAppearance write SetAppearance;
    procedure DoChanged(Sender: TObject);
    procedure Notification(AComponent: TComponent; Operation: TOperation); override;
    procedure Draw({%H-}AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF); override;
    procedure HandleMouseDown(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure HandleMouseMove(Shift: TShiftState; X, Y: Single); override;
    procedure HandleMouseUp(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single); override;
    procedure OCRFinished(Sender: TObject;Result: TTMSFNCWXOCRResult);
    procedure SetAspectSizeValues;
    procedure GetImagePart(dx, dy, sx, sy: single);{$IFDEF WEBLIB} async; {$ENDIF}
    function GetDpi: Single;
    function GetDocURL: string; override;
  public
    property SelectionResults: TTMSFNCWXOCRHelperSelectionResults read FSelectionResults;
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    procedure StartFullImageOCR;
    procedure ClearAll;
    procedure ClearNonProcessedSelections;
    procedure ResetOCR;
    procedure LoadTemplate(const Template: TTMSFNCWXOCRHelperSelectionTemplate);{$IFDEF WEBLIB} async; {$ENDIF}
    procedure LoadTemplateFromJSON(const JSON: string);{$IFDEF WEBLIB} async; {$ENDIF}
    function SaveToTemplate: TTMSFNCWXOCRHelperSelectionTemplate;
    function SaveTemplateToJSON: string;
    function CheckRectanglesAvailableForOCR: Boolean;
    Procedure StartOCR;
  end;

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsWeb)]
  {$ENDIF}
  TTMSFNCWXOCRHelper = class(TTMSFNCWXOCRCustomHelper)
  published
    property AutoStart;
    property OCR;
    property Bitmap;
    property LowConfidence;
    property ModerateConfidence;
    property ReasonableConfidence;
    property Appearance;
    property EnableSelection;
    property EnableFeedback;
  end;

implementation

type
  TTMSFNCWXOCROpen = class(TTMSFNCWXOCR);

  { TTMSFNCWXOCRCustomSelector }

function TTMSFNCWXOCRCustomHelper.CheckRectanglesAvailableForOCR: Boolean;
var
  i: Integer;
begin
  Result := False;
  for i := 0 to SelectionResults.Count - 1 do
  begin
    if not (SelectionResults[i].InProgress) and not Assigned(SelectionResults[i].OCRResult) then
      Result := True;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.ClearAll;
begin
  SelectionResults.Clear;
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.ClearNonProcessedSelections;
var
  i, j: Integer;
begin
  j := SelectionResults.Count - 1;
  for i := j downto 0 do
  begin
    if not (SelectionResults[i].InProgress) and not Assigned(SelectionResults[i].OCRResult) then
      SelectionResults.Delete(i);
  end;

  Invalidate;
end;

constructor TTMSFNCWXOCRCustomHelper.Create(AOwner: TComponent);
begin
  FBitmap := TTMSFNCBitmap.Create;
  FBitmap.OnChange := @DoChanged;
  FSelectionResults := TTMSFNCWXOCRHelperSelectionResults.Create;
  inherited;
  {$IFDEF CMNLIB}
  NativeCanvas := True;
  {$ENDIF}
  FAppearance := TTMSFNCWXOCRHelperAppearance.Create(Self);
  FAppearance.OnChange := @DoChanged;
  FLowConfidence := 30;
  FModerateConfidence := 50;
  FReasonableConfidence := 70;
  FEnableSelection := true;
  FEnableFeedback := true;
  Width := 400;
  Height := 600;
  FAutoStart := false;
end;

destructor TTMSFNCWXOCRCustomHelper.Destroy;
begin
  FBitmap.Free;
  FSelectionResults.Clear;
  FSelectionResults.Free;
  FAppearance.Free;
  inherited;
end;

procedure TTMSFNCWXOCRCustomHelper.DoChanged(Sender: TObject);
begin
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.HandleMouseDown(Button: TTMSFNCMouseButton; Shift: TShiftState; X, Y: Single);
begin
  inherited;
  FDown := True;
  FDX := X;
  FDY := Y;
  FSX := X;
  FSY := Y;
end;

procedure TTMSFNCWXOCRCustomHelper.HandleMouseMove(Shift: TShiftState; X,Y: Single);
begin
  inherited;
  if FDown and EnableSelection then
  begin
    FSX := X;
    FSY := Y;
    Invalidate;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.HandleMouseUp(Button: TTMSFNCMouseButton;Shift: TShiftState; X, Y: Single);
begin
  GetImagePart(FDX ,FDY , FSX, FSY);
end;

procedure TTMSFNCWXOCRCustomHelper.LoadTemplate(
  const Template: TTMSFNCWXOCRHelperSelectionTemplate);
var
  i: Integer;
  g: TTMSFNCGraphics;
  Selection: TTMSFNCWXOCRHelperSelectionResult;
  r: TRectF;
begin
  for i := 0 to Template.Count -1 do
  begin
    r := RectF(Template[i].Left, Template[i].Top, Template[i].Right ,Template[i].Bottom);
    {$IFNDEF WEBLIB}
    g := TTMSFNCGraphics.CreateBitmapCanvas(Round(r.Width / Template[i].DPIScale), Round(r.Height / Template[i].DPIScale), False, False);
    {$ENDIF}
    {$IFDEF WEBLIB}
    g := TTMSFNCGraphics.CreateBitmapCanvas(Round((r.Right - r.left)), Round((r.Bottom - r.top)), False, False);
    {$ENDIF}
    try
      g.BeginScene;
      Selection := TTMSFNCWXOCRHelperSelectionResult.Create;
      Selection.SelectionDPIScale := Template[i].DPIScale;
      {$IFNDEF WEBLIB}
      Selection.Rectangle := r;

      g.DrawBitmapPart(RectF(r.Left, r.Top, r.Left + r.Width / Template[i].DPIScale, r.top + r.Height  / Template[i].DPIScale), RectF(0, 0, r.Width / Template[i].DPIScale, r.Height  / Template[i].DPIScale), FBitmap, True, False, False, False);
      g.EndScene;
      Selection.Bitmap := TTMSFNCBitmap.Create;
      Selection.Bitmap.Assign(g.Bitmap);
      {$ENDIF}
      {$IFDEF WEBLIB}
      Selection.Rectangle := RectF(r.Left, r.Top, r.Right, r.Bottom);
      Selection.Bitmap := await (TTMSFNCBitmap,
                              g.DrawBitmapPartSync(Selection.Rectangle.Left, Selection.Rectangle.Top, Selection.Rectangle.Right, Selection.Rectangle.Bottom,
                              0, 0, r.Right - r.Left, r.Bottom - r.Top, FBitmap, True, False, False, False));
      g.EndScene;
      {$ENDIF}
      SelectionResults.Add(Selection);
      Selection.Id := IntToStr(SelectionResults.Count);
      Selection.FromTemplate := true;
    finally
      g.Free;
    end;
  end;

  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.LoadTemplateFromJSON(const JSON: String);
var
  l: TTMSFNCWXOCRHelperSelectionTemplate;
begin
  l := TTMSFNCWXOCRHelperSelectionTemplate.Create;
  try
    l.FromJSON(JSON);

    {$IFNDEF WEBLIB}
    LoadTemplate(l);
    {$ENDIF}
    {$IFDEF WEBLIB}
    await (LoadTemplate(l));
    {$ENDIF}

  finally
    l.Free;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.Notification(AComponent: TComponent;
  Operation: TOperation);
begin
  if (Operation = opRemove) and (AComponent = FOCR) then
    FOCR := nil;
  inherited;
end;

procedure TTMSFNCWXOCRCustomHelper.OCRFinished(Sender: TObject; Result: TTMSFNCWXOCRResult);
var
  i: Integer;
begin
  for i := 0 to SelectionResults.Count -1 do
  begin
    if SelectionResults[i].ID = Result.ID then
    begin
      SelectionResults[i].OCRResult := Result;
      SelectionResults[i].InProgress := False;
    end;
  end;

  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.ResetOCR;
begin
  FOCR.Terminate;
  SelectionResults.Clear;
  Invalidate;
end;

function TTMSFNCWXOCRCustomHelper.SaveTemplateToJSON: String;
var
  l: TTMSFNCWXOCRHelperSelectionTemplate;
begin
  l := SaveToTemplate;
  try
    Result := l.ToJSON;
  finally
    l.Free;
  end;
end;

function TTMSFNCWXOCRCustomHelper.SaveToTemplate: TTMSFNCWXOCRHelperSelectionTemplate;
var
  i: Integer;
  t: TTMSFNCWXOCRHelperRectangle;
begin
  Result := TTMSFNCWXOCRHelperSelectionTemplate.Create;
  for i := 0 to SelectionResults.Count -1 do
  begin
    t := TTMSFNCWXOCRHelperRectangle.Create;
    t.Left := SelectionResults[i].Rectangle.Left;
    t.Top := SelectionResults[i].Rectangle.Top;
    t.Right := SelectionResults[i].Rectangle.Right;
    t.Bottom := SelectionResults[i].Rectangle.Bottom;
    t.DPIScale := GetDpi;
    Result.Add(t);
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.SetAppearance(
  const Value: TTMSFNCWXOCRHelperAppearance);
begin
  FAppearance.Assign(Value);
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.SetAspectSizeValues;
var
  w, h: Single;
begin
  TTMSFNCGraphics.GetAspectSize(w, h, FBitmap.width, FBitmap.Height, Self.Width, Self.Height);

  if (w = 0) or (h = 0) then
  begin
    FWidthMultiplier := 1;
    FHeightMultiplier := 1;
  end
  else if (w = FBitmap.width) and (h = FBitmap.Height)  then
  begin
    FWidthMultiplier := 1;
    FHeightMultiplier := 1;
  end
  else
  begin
    FWidthMultiplier := FBitmap.Width / w;
    FHeightMultiplier := FBitmap.Height / h;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.SetAutoStart(const Value: Boolean);
begin
  if Value <> FAutoStart then
    FAutoStart := Value;
end;

procedure TTMSFNCWXOCRCustomHelper.SetBitmap(const Value: TTMSFNCBitmap);
begin
  if Value <> FBitmap then
  begin
    FBitmap.Assign(Value);
    Invalidate;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.SetEnableFeedback(const Value: Boolean);
begin
  FEnableFeedback := value;
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.SetEnableSelection(const Value: Boolean);
begin
  FEnableSelection := value;
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.SetLowConfidence(const Value: Single);
begin
  FLowConfidence := Value;
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.SetModerateConfidence(const Value: Single);
begin
  FModerateConfidence := Value;
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.SetOCR(const Value: TTMSFNCWXOCR);
begin
  if Value <> FOCR then
  begin
    if Assigned(TTMSFNCWXOCROpen(Value).OnFinishOCRInternal) then
    begin
      raise Exception.Create('TTMSFNCWXOCR already assigned to another TTMSFNCWXOCRHelper!');
    end;

    FOCR := Value;
    if Assigned(FOCR) then
      TTMSFNCWXOCROpen(FOCR).OnFinishOCRInternal := {$IFDEF LCLLIB}@{$ENDIF}OCRFinished;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.SetReasonableConfidence(
  const Value: Single);
begin
  FReasonableConfidence := Value;
  Invalidate;
end;

procedure TTMSFNCWXOCRCustomHelper.StartFullImageOCR;
var
  Selection: TTMSFNCWXOCRHelperSelectionResult;
  {$IFDEF WEBLIB}
  s: string;
  o: TJSObject;
  {$ENDIF}
begin
  Selection := TTMSFNCWXOCRHelperSelectionResult.Create;
  Selection.Bitmap := TTMSFNCBitmap.Create;
  Selection.Bitmap.Assign(FBitmap);
  Selection.SelectionDPIScale := 1;
  Selection.FeedbackDPIScale := 1;
  SelectionResults.Add(Selection);
  Selection.InProgress := true;
  Selection.ID := IntToStr(SelectionResults.Count);
  {$IFNDEF WEBLIB}
  FOCR.RecognizeBase64(TTMSFNCUtils.SaveBitmapToBase64(Selection.Bitmap), Selection.ID);
  {$ENDIF}
  {$IFDEF WEBLIB}
  o := Selection.Bitmap.Image;
  asm
    s = o.src;
  end;
  FOCR.RecognizeURL(s, Selection.ID);
  {$ENDIF}
end;

procedure TTMSFNCWXOCRCustomHelper.Draw({%H-}AGraphics: TTMSFNCGraphics; {%H-}ARect: TRectF);
var
  i, j: integer;
  ax, ay, bx, by: Single;
begin
  inherited;

  if Assigned(FBitmap) then
    AGraphics.DrawBitmap(Self.LocalRect, FBitmap,True, True, false);

  SetAspectSizeValues;

  if FDown and EnableSelection then
  begin
    AGraphics.Fill.Assign(FAppearance.DragFill);
    AGraphics.Stroke.Assign(FAppearance.DragStroke);
    AGraphics.DrawRectangle(RectF(FDX, FDY, FSX, FSY));
  end;

  if EnableFeedback = False then
    Exit;

  for i := 0 to SelectionResults.Count - 1 do
  begin
    if SelectionResults[i].Rectangle.Right - SelectionResults[i].Rectangle.Left <> 0 then
    begin
      ax := SelectionResults[i].Rectangle.Left / FWidthMultiplier;
      ay := SelectionResults[i].Rectangle.Top / FHeightMultiplier;
      {$IFNDEF WEBLIB}
      bx := ((SelectionResults[i].Rectangle.Left + SelectionResults[i].Rectangle.Width / SelectionResults[i].SelectionDPIScale) / FWidthMultiplier);
      by :=  ((SelectionResults[i].Rectangle.Top + SelectionResults[i].Rectangle.Height / SelectionResults[i].SelectionDPIScale) / FHeightmultiplier);
      {$ENDIF}
      {$IFDEF WEBLIB}
      bx := SelectionResults[i].Rectangle.Right / FWidthMultiplier;
      by := SelectionResults[i].Rectangle.Bottom / FHeightMultiplier;
      {$ENDIF}
      AGraphics.Fill.Assign(FAppearance.SelectionFill);
      AGraphics.Stroke.Assign(FAppearance.SelectionStroke);
      AGraphics.Font.Color := gcWhite;
      AGraphics.DrawRectangle(RectF(ax, ay, bx, by));
      AGraphics.Fill.Color := FAppearance.SelectionStroke.Color;
      AGraphics.Fill.Kind := gfkSolid;
      if ay > 22 then
      begin
        AGraphics.DrawRoundRectangle(RectF(bx - 22, ay - 22, bx - 2, ay - 2),3);
        AGraphics.DrawText(RectF(bx - 22, ay - 22, bx - 2, ay - 2), SelectionResults[i].ID, False, gtaCenter, gtaCenter);
      end
      else
      begin
        AGraphics.DrawRoundRectangle(RectF(bx - 22, ay + 2, bx - 2, ay + 22),3);
        AGraphics.DrawText(RectF(bx - 22, ay + 2, bx - 2, ay + 22), SelectionResults[i].ID, False, gtaCenter, gtaCenter);
      end;
      end
    else
    begin
      ax := 0;
      ay := 0;
    end;

    if Assigned(SelectionResults[i].OCRResult) then
    begin
      for j := 0 to SelectionResults[i].OCRResult.Words.Count - 1 do
      begin
        if SelectionResults[i].OCRResult.Words[j].Confidence < FLowConfidence then
        begin
          AGraphics.Fill.Assign(FAppearance.LowConfidenceFill);
          AGraphics.Stroke.Assign(FAppearance.LowConfidenceStroke);
          {$IFDEF WEBLIB}
          AGraphics.Canvas.Context.GlobalAlpha := FAppearance.LowConfidenceFill.Opacity;
          {$ENDIF}
          AGraphics.DrawRectangle(RectF(
            (SelectionResults[i].OCRResult.words[j].Bbox.X0 / FWidthMultiplier / SelectionResults[i].FeedbackDPIScale + ax),
            (SelectionResults[i].OCRResult.words[j].Bbox.y0 / FHeightMultiplier / SelectionResults[i].FeedbackDPIScale + ay),
            (SelectionResults[i].OCRResult.words[j].Bbox.X1 / FWidthMultiplier / SelectionResults[i].FeedbackDPIScale + ax),
            (SelectionResults[i].OCRResult.words[j].Bbox.y1 / FHeightMultiplier / SelectionResults[i].FeedbackDPIScale + ay)));
          {$IFDEF WEBLIB}
          AGraphics.Canvas.Context.GlobalAlpha := 1;
          {$ENDIF}
        end
        else if SelectionResults[i].OCRResult.words[j].Confidence < FModerateConfidence then
        begin
          AGraphics.Fill.Assign(FAppearance.ModerateConfidenceFill);
          AGraphics.Stroke.Assign(FAppearance.ModerateConfidenceStroke);
          {$IFDEF WEBLIB}
          AGraphics.Canvas.Context.GlobalAlpha := FAppearance.ModerateConfidenceFill.Opacity;
          {$ENDIF}
          AGraphics.DrawRectangle(RectF(
            (SelectionResults[i].OCRResult.words[j].Bbox.X0 / FWidthMultiplier / SelectionResults[i].FeedbackDPIScale + ax),
            (SelectionResults[i].OCRResult.words[j].Bbox.y0 / FHeightMultiplier / SelectionResults[i].FeedbackDPIScale + ay),
            (SelectionResults[i].OCRResult.words[j].Bbox.X1 / FWidthMultiplier / SelectionResults[i].FeedbackDPIScale + ax),
            (SelectionResults[i].OCRResult.words[j].Bbox.y1 / FHeightMultiplier / SelectionResults[i].FeedbackDPIScale + ay)));
          {$IFDEF WEBLIB}
          AGraphics.Canvas.Context.GlobalAlpha := 1;
          {$ENDIF}
        end
        else if SelectionResults[i].OCRResult.words[j].Confidence < FReasonableConfidence then
        begin
          AGraphics.Fill.Assign(FAppearance.ReasonableConfidenceFill);
          AGraphics.Stroke.Assign(FAppearance.ReasonableConfidenceStroke);
          {$IFDEF WEBLIB}
          AGraphics.Canvas.Context.GlobalAlpha := FAppearance.ReasonableConfidenceFill.Opacity;
          {$ENDIF}
          AGraphics.DrawRectangle(RectF(
            (SelectionResults[i].OCRResult.words[j].Bbox.X0 / FWidthMultiplier / SelectionResults[i].FeedbackDPIScale + ax),
            (SelectionResults[i].OCRResult.words[j].Bbox.y0 / FHeightMultiplier / SelectionResults[i].FeedbackDPIScale + ay),
            (SelectionResults[i].OCRResult.words[j].Bbox.X1 / FWidthMultiplier / SelectionResults[i].FeedbackDPIScale + ax),
            (SelectionResults[i].OCRResult.words[j].Bbox.y1 / FHeightMultiplier / SelectionResults[i].FeedbackDPIScale + ay)));
          {$IFDEF WEBLIB}
          AGraphics.Canvas.Context.GlobalAlpha := 1;
          {$ENDIF}
        end;
      end;
    end;
  end;
end;

procedure TTMSFNCWXOCRCustomHelper.StartOCR;
var
  i, j: Integer;
  {$IFDEF WEBLIB}
  s: string;
  o: TJSOBject;
  {$ENDIF}
begin
  j := 0;
  for i := 0 to SelectionResults.Count -1 do
  begin
    if Assigned(Selectionresults.Items[i].OCRResult) then
      Continue;

    if Selectionresults[i].InProgress then
      Continue;

    {$IFNDEF WEBLIB}
    FOCR.RecognizeBase64(TTMSFNCUtils.SaveBitmapToBase64(Selectionresults[i].Bitmap), Selectionresults[i].ID);
    {$ENDIF}
    {$IFDEF WEBLIB}
    o := Selectionresults.Items[i].Bitmap.Image;
    asm
      s = o.src;
    end;
    FOCR.RecognizeBase64(s, Selectionresults[i].ID);
    {$ENDIF}

    SelectionResults.Items[i].InProgress := True;
    SelectionResults[i].FeedbackDPIScale := GetDpi;
    inc(j);
  end;

  if j = 0 then
    StartFullImageOCR;
end;

function TTMSFNCWXOCRCustomHelper.GetDocURL: string;
begin
Result := 'https://download.tmssoftware.com/doc/tmsfncwxpack/components/ttmsfncwxocrhelper/';
end;

function TTMSFNCWXOCRCustomHelper.GetDpi: Single;
begin
  {$IFNDEF CMNLIB}
  Result := TTMSFNCUtils.GetDPIScale(Self);
  if Result = 0 then
    Result := 1;
  {$ENDIF}
  {$IFDEF CMNLIB}
  Result := 1;
  {$ENDIF}
end;

procedure TTMSFNCWXOCRCustomHelper.GetImagePart(dx, dy, sx, sy: single);
var
  g: TTMSFNCGraphics;
  dpi: Single;
  r: TRectF;
  Selection: TTMSFNCWXOCRHelperSelectionResult;
  {$IFDEF WEBLIB}
  s: string;
  o: TJSOBject;
  {$ENDIF}
begin
  inherited;
  FDown := false;

  dpi := GetDpi;

  if EnableSelection = false then
    Exit;

  dx := dx * FWidthMultiplier;
  dy := dy * FHeightMultiplier;
  sx := sx * FWidthMultiplier;
  sy := sy * FHeightMultiplier;

  if (dx = sx) or (dy = sy) then
     Exit;

  if (dx > sx) and (dy > sy)  then
    r := RectF(sx, sy, dx, dy)
  else if (dx > sx) then
    r := RectF(sx, dy, dx, sy)
  else if (dy > sy) then
    r := RectF(dx, sy, sx, dy)
  else
    r := RectF(dx, dy, sx, sy);

  {$IFNDEF WEBLIB}
  g := TTMSFNCGraphics.CreateBitmapCanvas(Round(r.Width * dpi), Round(r.Height * dpi), False, False);
  {$ENDIF}
  {$IFDEF WEBLIB}
  g := TTMSFNCGraphics.CreateBitmapCanvas(Round((r.Right - r.left)), Round((r.Bottom - r.top)), False, False);
  {$ENDIF}
  try
    g.BeginScene;
    Selection := TTMSFNCWXOCRHelperSelectionResult.Create;
    Selection.SelectionDPIScale := dpi;
    {$IFNDEF WEBLIB}
    Selection.Rectangle := RectF(r.Left, r.Top, r.Left + r.Width * dpi, r.Top + r.Height * dpi);
    g.DrawBitmapPart(Selection.Rectangle, RectF(0, 0, r.Width * dpi , r.Height * dpi), FBitmap, True, False, False, False);
    g.EndScene;
    Selection.Bitmap := TTMSFNCBitmap.Create;
    Selection.Bitmap.Assign(g.Bitmap);
    if AutoStart then
    begin
      FOCR.RecognizeBase64(TTMSFNCUtils.SaveBitmapToBase64(Selection.Bitmap),Selection.ID);
      Selection.InProgress := true;
      Selection.FeedbackDPIScale := dpi;
    end;
    {$ENDIF}
    {$IFDEF WEBLIB}
    Selection.Rectangle := RectF(r.Left, r.Top, r.Right, r.Bottom);
    Selection.Bitmap := await (TTMSFNCBitmap,
                              g.DrawBitmapPartSync(Selection.Rectangle.Left, Selection.Rectangle.Top, Selection.Rectangle.Right, Selection.Rectangle.Bottom,
                              0, 0, r.Right - r.Left, r.Bottom - r.Top, FBitmap, True, False, False, False));
    g.EndScene;

    if AutoStart then
    begin
      o := Selection.Bitmap.Image;
      asm
        s = o.src;
      end;
      FOCR.RecognizeBase64(s, Selection.ID);
      Selection.InProgress := true;
    end;
    {$ENDIF}

    SelectionResults.Add(Selection);
    Selection.ID := IntToStr(SelectionResults.Count);
  finally
    g.Free;
  end;

  Invalidate;
end;

{ TTMSFNCWXOCRSelectionResult }

destructor TTMSFNCWXOCRHelperSelectionResult.Destroy;
begin
  FBitmap.Free;
  inherited;
end;

{ TTMSFNCWXOCRSelectorAppearance }

procedure TTMSFNCWXOCRHelperAppearance.Assign(Source: TPersistent);
begin
  if Source is TTMSFNCWXOCRHelperAppearance then
  begin
    FDragFill.Assign((Source as TTMSFNCWXOCRHelperAppearance).DragFill);
    FDragStroke.Assign((Source as TTMSFNCWXOCRHelperAppearance).DragStroke);
    FSelectionFill.Assign((Source as TTMSFNCWXOCRHelperAppearance).SelectionFill);
    FSelectionStroke.Assign((Source as TTMSFNCWXOCRHelperAppearance).SelectionStroke);
    FLowConfidenceFill.Assign((Source as TTMSFNCWXOCRHelperAppearance).LowConfidenceFill);
    FLowConfidenceStroke.Assign((Source as TTMSFNCWXOCRHelperAppearance).LowConfidenceStroke);
    FModerateConfidenceFill.Assign((Source as TTMSFNCWXOCRHelperAppearance).ModerateConfidenceFill);
    FModerateConfidenceStroke.Assign((Source as TTMSFNCWXOCRHelperAppearance).ModerateConfidenceStroke);
    FReasonableConfidenceFill.Assign((Source as TTMSFNCWXOCRHelperAppearance).ReasonableConfidenceFill);
    FReasonableConfidenceStroke.Assign((Source as TTMSFNCWXOCRHelperAppearance).ReasonableConfidenceStroke);
  end
  else
    inherited Assign(Source);
end;

procedure TTMSFNCWXOCRHelperAppearance.Changed;
begin
  if Assigned(OnChange) then
    Onchange(Self);
end;

constructor TTMSFNCWXOCRHelperAppearance.Create(AOwner: TComponent);
begin
  FOwner := AOwner;
  FLowConfidenceFill := TTMSFNCGraphicsFill.create(gfkSolid, gcRed);
  FLowConfidenceFill.Opacity := 0.4;
  FLowConfidenceFIll.OnChanged := @FillChanged;
  FLowConfidenceStroke := TTMSFNCGraphicsStroke.Create(gskNone, gcNull);
  FLowConfidenceStroke.OnChanged := @StrokeChanged;
  FModerateConfidenceFill := TTMSFNCGraphicsFill.create(gfkSolid, gcOrange);
  FModerateConfidenceFill.Opacity := 0.4;
  FModerateConfidenceFill.OnChanged := @FillChanged;
  FModerateConfidenceStroke := TTMSFNCGraphicsStroke.Create(gskNone, gcNull);
  FModerateConfidenceStroke.OnChanged := @StrokeChanged;
  FReasonableConfidenceFill := TTMSFNCGraphicsFill.create(gfkSolid, gcYellow);
  FReasonableConfidenceFill.Opacity := 0.4;
  FReasonableConfidenceFill.OnChanged := @FillChanged;
  FReasonableConfidenceStroke := TTMSFNCGraphicsStroke.Create(gskNone, gcNull);
  FReasonableConfidenceStroke.OnChanged := @StrokeChanged;
  FDragFill := TTMSFNCGraphicsFill.Create(gfkNone, gcNull);
  FDragFill.OnChanged := @FillChanged;
  FDragStroke := TTMSFNCGraphicsStroke.Create(gskDot, gcBlue);
  FDragStroke.OnChanged := @StrokeChanged;
  FSelectionFill := TTMSFNCGraphicsFill.Create(gfkNone, gcNull);
  FSelectionFill.OnChanged := @FillChanged;
  FSelectionStroke := TTMSFNCGraphicsStroke.Create(gskSolid, gcBlue);
  FSelectionStroke.OnChanged := @StrokeChanged;
end;

destructor TTMSFNCWXOCRHelperAppearance.Destroy;
begin
  FDragFill.Free;
  FDragStroke.Free;
  FSelectionFill.Free;
  FSelectionStroke.Free;
  FLowConfidenceFill.Free;
  FLowConfidenceStroke.Free;
  FModerateConfidenceFill.Free;
  FModerateConfidenceStroke.Free;
  FReasonableConfidenceFill.Free;
  FReasonableConfidenceStroke.Free;
  inherited;
end;

procedure TTMSFNCWXOCRHelperAppearance.FillChanged(Sender: TObject);
begin
  Changed;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetDragFill(
  const Value: TTMSFNCGraphicsFill);
begin
  if Value <> FDragFill then
  begin
    FDragFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetDragStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  if Value <> FDragStroke then
  begin
    FDragFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetLowConfidenceFill(
  const Value: TTMSFNCGraphicsFill);
begin
  if Value <> FLowConfidenceFill then
  begin
    FLowConfidenceFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetLowConfidenceStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  if Value <> FLowConfidenceStroke then
  begin
    FLowConfidenceStroke.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetModerateConfidenceFill(
  const Value: TTMSFNCGraphicsFill);
begin
  if Value <> FModerateConfidenceFill then
  begin
    FModerateConfidenceFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetModerateConfidenceStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  if Value <> FModerateConfidenceStroke then
  begin
    FModerateConfidenceStroke.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetReasonableConfidenceFill(
  const Value: TTMSFNCGraphicsFill);
begin
  if Value <> FReasonableConfidenceFill then
  begin
    FReasonableConfidenceFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetReasonableConfidenceStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  if Value <> FReasonableConfidenceStroke then
  begin
    FReasonableConfidenceStroke.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetSelectionFill(
  const Value: TTMSFNCGraphicsFill);
begin
  if Value <> FSelectionFill then
  begin
    FSelectionFill.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.SetSelectionStroke(
  const Value: TTMSFNCGraphicsStroke);
begin
  if Value <> FSelectionStroke then
  begin
    FSelectionStroke.Assign(Value);
    Changed;
  end;
end;

procedure TTMSFNCWXOCRHelperAppearance.StrokeChanged(Sender: TObject);
begin
  Changed;
end;

{ TTMSFNCWXOCRHelperSelectionResultList }

function TTMSFNCWXOCRHelperSelectionTemplate.CreateObject(
  const AClassName: string; const ABaseClass: TClass): TObject;
begin
  Result := nil;
  if ABaseClass = TTMSFNCWXOCRHelperRectangle then
    Result := TTMSFNCWXOCRHelperRectangle.Create;
end;

function TTMSFNCWXOCRHelperSelectionTemplate.GetItemClass: TClass;
begin
  Result := TTMSFNCWXOCRHelperRectangle;
end;

{$IFDEF LCLLIB}
function TTMSFNCWXOCRHelperSelectionTemplate.QueryInterface({$IFDEF FPC_HAS_CONSTREF}constref{$ELSE}const{$ENDIF} IID: TGUID; out Obj): HResult; {$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};
{$ELSE}
function TTMSFNCWXOCRHelperSelectionTemplate.QueryInterface(const IID: TGUID;out Obj): HResult;
{$ENDIF}
const
  E_NOINTERFACE = HResult($80004002);
begin
  if GetInterface(IID, Obj) then Result := 0 else Result := E_NOINTERFACE;
end;

function TTMSFNCWXOCRHelperSelectionTemplate._AddRef: {$IFDEF LCLLIB} LongInt; {$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};{$ELSE} Integer;{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._AddRef else
    Result := -1;
end;

function TTMSFNCWXOCRHelperSelectionTemplate._Release: {$IFDEF LCLLIB} LongInt; {$IFNDEF WINDOWS}cdecl{$ELSE}stdcall{$ENDIF};{$ELSE} Integer;{$ENDIF}
begin
  if FOwnerInterface <> nil then
    Result := FOwnerInterface._Release else
    Result := -1;
end;

{$IFDEF WEBLIB}
function TTMSFNCWXOCRHelperSelectionResults.GetItem(Index: Integer): TTMSFNCWXOCRHelperSelectionResult;
begin
  Result := TTMSFNCWXOCRHelperSelectionResult(inherited Items[Index]);
end;

procedure TTMSFNCWXOCRHelperSelectionResults.SetItem(Index: Integer; const Value: TTMSFNCWXOCRHelperSelectionResult);
begin
  inherited Items[Index] := Value;
end;

function TTMSFNCWXOCRHelperSelectionTemplate.GetItem(Index: Integer): TTMSFNCWXOCRHelperRectangle;
begin
  Result := TTMSFNCWXOCRHelperRectangle(inherited Items[Index]);
end;

procedure TTMSFNCWXOCRHelperSelectionTemplate.SetItem(Index: Integer; const Value: TTMSFNCWXOCRHelperRectangle);
begin
  inherited Items[Index] := Value;
end;
{$ENDIF}

end.

